import { Injectable } from '@angular/core';
import {
  IReviewSettingsPayload,
  ISendRequestReviewPayload,
} from './review-data.actions';
import {
  IReviewSettingsRequestPayload,
  ISendRequestReviewRequestPayload,
} from './review-data.data';

@Injectable()
export class ReviewDataBuilder {
  constructor() {}

  buildSendRequestReviewRequestPayload(
    payload: ISendRequestReviewPayload
  ): ISendRequestReviewRequestPayload {
    const { messageData, reviewRequestId, clientEmail } = payload;
    const { subject, message } = messageData;
    const body = message.replace(/[\n]/g, '<br/>');

    return {
      request_id: reviewRequestId,
      to_address: clientEmail,
      email_message: {
        subject,
        body,
      },
    };
  }

  buildReviewSettingsRequestPayload(
    payload: IReviewSettingsPayload
  ): IReviewSettingsRequestPayload {
    const { reviewSettings } = payload;

    return {
      review_settings: reviewSettings,
    };
  }
}
